<template>
  <div style="margin: 30px;">
    <div class="text-left">
      <naj-button
        color="primary"
        @click="handleNewRequest"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        {{ local.waiverRequest.newRequest }}
      </naj-button>
    </div>
    <div class="mt-2">
      <naj-search-box
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithRequestCode"
        :search.sync="searchQuery.requestCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
    </div>
    <div
      v-if="hasFilter"
      class="filter-row-wrapper d-flex mt-3"
    >
      <div class="col-12">
        <template v-for="filter in filters">
          <span
            v-if="searchQuery[filter.name]"
            :key="filter.name"
            class="ma-1"
          >
            <v-chip
              :key="filter.name"
              :input-value="searchQuery[filter.name]"
              color="#F7FBFB"
              close
              outlined
              @click:close="searchQuery[filter.name]=null ; filterData();"
            >
              <strong class="text-primary">{{ filter.label + ':' + (searchQuery[filter.name+'DisplayName'] || searchQuery[filter.name]) }}</strong>
            </v-chip>
          </span>
        </template>
      </div>
    </div>

    <v-row class="mt-7">
      <v-col :cols="showFilter?9:12">
        <naj-item-table
          :data-items="data.list"
          :headers="headers"
          :loading="loading"
          :items-per-page="20"
          :server-items-length="pagination.totalCount"
          @update:page="onPageChange"
        >
          <template
            slot="requestCode"
            slot-scope="{item}"
          >
            <div class="info-item-details-title">
              {{ local.home.tabCommon.deedId }}
            </div>
            <div class="info-item-details-value mt-2">
              {{ item.requestCode }}
            </div>
          </template>
          <template
            slot="actionSave"
            slot-scope="{item}"
          >
            <div v-if=" item.waiverTypeId == waiverTypeEnum.waiverWithConditions && !item.isConditionValide">
              <naj-button @click="showWaiverRequestInfo(item)">
                {{ local.home.judgementDelivery.show }}
              </naj-button>
            </div>
            <div
              v-else
              class="action-placeholder"
            />
          </template>
        </naj-item-table>
      </v-col>
      <v-col
        v-if="showFilter"
        cols="3"
      >
        <v-card color="pa-3">
          <v-row>
            <v-col class="pt-0">
              <div class="text-left">
                <v-icon
                  class="icon"
                  @click="toggleFilter()"
                >
                  mdi-close
                </v-icon>
              </div>
              <div class="text-h4 font-weight-bold">
                {{ local.common.filter }}
              </div>
            </v-col>
            <v-col
              v-for="filter in filters"
              :key="filter.name"
              cols="12"
            >
              <naj-input
                :type-id="filter.typeId"
                :label="filter.label"
                :value.sync="searchQuery[filter.name]"
                :value-name.sync="searchQuery[filter.name+'DisplayName']"
                :items="filter.items"
                item-text="name"
                item-value="id"
              ></naj-input>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
            >
              <naj-button
                :loading="loading"
                @click="filterData()"
              >
                {{ local.common.filter }}
              </naj-button>

              <naj-button
                outlined
                @click="toggleFilter()"
              >
                {{ local.common.close }}
              </naj-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);
import { toHijriDate } from '@/helpers/utils';
import { waiverTypeEnum } from '@/helpers/enum';
export default {
  name: 'Waiver',
  data() {
    return {
      searchQuery: {
        requestStatusId: null,
        requestCode: null,
        objectKey: this.$route.params.caseObjectKey,
      },
      waiverTypeEnum,
      loading: false,
      showFilter: false,
      data: { list: [] },
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      headers: [
        {
          value: 'requestCode',
          text: this.local.home.petitionRequests.requestCode,
          isCustomTemplate: false,
          class: 'requestCode-header',
        },
        {
          value: 'courtName',
          text: this.local.home.petitionRequests.courtName,
        },
        {
          value: 'requestDate',
          text: this.local.home.petitionRequests.requestDate,
          formatter: toHijriDate,
        },
        {
          value: 'requestStatusName',
          text: this.local.home.petitionRequests.requestStatus,
        },
        {
          value: 'actionSave',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
    };
  },
  computed: {
    ...mapLUTState(['requestStatus']),
    filters() {
      return [
        this.mapFilterItem('requestStatusId', 'requestStatus', 'selectbox', this.requestStatus),
        this.mapFilterItem('requestCode', 'requestCode', 'text'),
      ];
    },
    hasFilter() {
      return this.searchQuery.requestStatusId || this.searchQuery.requestCode;
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          requestCode: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          requestCode: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
  },
  mounted() { this.init(); },
  methods: {
    ...mapLUTActions(['getRequestStatus']),
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.home.filter[key],
        typeId: this.formFieldType[typeId],
        items,
      };
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    ...mapCasesActions(['getWaiverCaseRequests']),
    init() {
      this.loadData();
      this.getRequestStatus();
    },
    loadData() {
      this.loading = true;
      this.getWaiverCaseRequests({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
          this.$emit('updateTabCount', this.pagination.totalCount);
        });
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    handleNewRequest() {
      const route = `/cases/${this.$route.params.caseObjectKey}/case-related-request/waiver-request/new?isPega=true&objectKey=${this.$route.params.judgmentObjectKey}`;
      this.$router.push(route);
    },
    showWaiverRequestInfo(item) {
      const route = `/cases/case-related-request/waiver-request/${item.objectKey}?isPega=true&isFromNonCaseParty=false&parentRequestObjectKey`;
      this.$router.push(route);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-placeholder {
  visibility: hidden;
  display: inline-block;
  min-width: 120px;
  height: 36px;
}
::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}

::v-deep .info-item-details.judgementCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}
</style>